import React, { useContext, useEffect, useState } from 'react';
import { MainContext } from '../context/main.context';


export default function ModalGlobal() {
    const [ isVisible, setIsVisible ] = useState<boolean>(false);
    const [ hideCloseBtn, setHideCloseBtn ] = useState<boolean>(false);
    const [ isLoadData, setIsLoadData ] = useState<boolean>(true);

    const {
        modalContent,
        setModalContent,
        setSession,
        setSource,
        setLocale,
        setProject,
        setPaymentId,
        setJwt
    } = useContext(MainContext);

    useEffect(() => {
        if (modalContent) {
            setIsLoadData(true);
            setIsVisible(true);

            const displayName: string | undefined = modalContent?.component?.type?.displayName;

            if (displayName) {
                if (['PaymentsYookassa', 'PaymentsStripe', 'PaymentsYandexPay'].includes(displayName)) {
                    setHideCloseBtn(true);
                }
            } else {
                setHideCloseBtn(false);
            }

            const data: any = modalContent?.values;

            if (data) {
                _setData(data).then(() => setIsLoadData(false));
            } else {
                setIsLoadData(false);
            }
        }
    }, [ modalContent ]);

    useEffect(() => {
        return () => {
            _clearData();
        }
    }, []);

    const handleClose = () => {
        if (hideCloseBtn) {
            return;
        }

        setIsVisible(false);
        setTimeout(() => setModalContent(null), 300);
    };

    const _setData = async (data: any) => {
        if (data?.session) {
            setSession(data.session);
        }

        if (data?.jwt) {
            setJwt(data.jwt);
        }

        if (data?.source) {
            setSource(data.source);
        }

        if (data?.locale) {
            setLocale(data.locale);
        }

        if (data?.project) {
            setProject(data.project);
        }

        if (data?.id) {
            setPaymentId(data.id);
        }
    };

    const _clearData = () => {
        setSession(null);
        setJwt(null);
        setSource(null);
        setLocale(null);
        setLocale(null);
        setProject(null);
    }

    if (!modalContent || isLoadData) {
        return null;
    }

    return (
        <div className={`modal-overlay ${isVisible ? 'visible' : ''}`} onClick={handleClose}>
            <div className="modal-content-wrapper" onClick={(e) => e.stopPropagation()}>
                { modalContent.component }
            </div>
        </div>
    );
};


